import React, { useEffect, useState } from 'react';

import MetaTags from 'react-meta-tags';
import Box from "@material-ui/core/Box";
import GeneralStyles from '../../styles/GeneralStyles';
import axios from 'axios';
import clsx from "clsx";
import { useCookies } from 'react-cookie';
import cookieName from '../../helpers/cookiesDeclaration';
import CircularProgress from '@material-ui/core/CircularProgress';
import moment from 'moment';


const useGeneralStyles = GeneralStyles;


function TermsAndConditions(props) {
    const classesG = useGeneralStyles();
    const [loading, setLoading] = useState(false);
    const [cookies, setCookie] = useCookies([cookieName]);

    const [termsPage, setTermsPage] = useState(null);
    const [termsCategories, setTermsCategories] = useState(null);

    useEffect(() => {
        setLoading(true);
        axios
            .get(
                `${process.env.REACT_APP_GATEWAY_END_POINT}/terma-and-conditions`)
            .then((response) => {
                setTermsPage(response.data);
            })
            .catch((error) => {
                setLoading(true);
            });

        axios
            .get(
                `${process.env.REACT_APP_GATEWAY_END_POINT}/terms-and-conditions-categories?_sort=Title:DESC`)
            .then((response) => {
                setTermsCategories(response.data);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(true);
            });
    }, []);

    const handleRedirectCategory = item => {
        var userD = {};
        userD.urlCatagory = item;
        setCookie(cookieName, JSON.stringify(userD), { path: '/' });

        const { history, location } = props;
        const { from } = location.state || {
            from: {
                pathname: `/terms&Conditions_categories/${item}`,
            },
        };
        history.push(from);
    };

    const replace = (param) => {
        var value = '';

        if (param !== '' && param !== null && param !== undefined) {
            value = param.replace(`${process.env.REACT_APP_GATEWAY_PATH_REPLACE}`, `${process.env.REACT_APP_GATEWAY_PATH_S3}`);
        }

        return value;
    }

    return (
        <React.Fragment>
            {loading && (
                <div className={classesG.divProgress}>
                    <CircularProgress size={68} className={classesG.progress} />
                </div>
            )}
            {!loading && (
                <React.Fragment>
                    {termsPage === null ? '' : (
                        <MetaTags>
                            <title>{termsPage.Page_title}</title>
                            <meta name="description" content={termsPage.Page_description} />
                        </MetaTags>
                    )}
                    {termsPage === null || termsPage === undefined ? '' : (
                        <div className={classesG.container}>
                            <section className={classesG.section}>
                                <div className={classesG.termsAndConditionsPage}>
                                    <div className={classesG.termsAndConditionsBox}>
                                        <div className={classesG.termsAndConditionsSectionTitle}>
                                            <h2>{termsPage.Title}</h2>
                                            <span style={{ marginTop: '10px', width: '81%', }}>
                                                {moment(termsPage.Date).format("MMMM Do, YYYY")}
                                            </span>
                                            <br />
                                        </div>


                                        <div className={classesG.termsAndConditionsCategories}>
                                            {termsCategories === null ? '' : termsCategories.map((items, i) => (
                                                <div key={i} className={classesG.termsAndConditionsCategoriesBox}>
                                                    <h2>{(items.Title).toUpperCase()}</h2>
                                                    <a onClick={() => handleRedirectCategory(items.Url)}>
                                                        Learn more
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </section>

                            <Box mt={20}></Box>
                        </div>
                    )}
                </React.Fragment>
            )}
        </React.Fragment>
    );
}

export default (TermsAndConditions);